import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// material
import { Box, Card, Link, Typography, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
// utils
import { fFormataDinheiro } from '../../utils/formatNumber';

// ----------------------------------------------------------------------

const ProductImgStyle = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  position: 'absolute',
});

// ----------------------------------------------------------------------

MesasCard.propTypes = {
  product: PropTypes.object,
};

export default function MesasCard({ product }) {
  const { id, name, cover, price } = product;

  return (
    <Card>
      <Box sx={{ pt: '100%', position: 'relative' }}>
        
        <Link to={`/venda_comercio/consultar/${id}`} color="inherit" underline="hover" component={RouterLink}>
          <ProductImgStyle alt={name} src={cover} />
        </Link>

      </Box>

      <Stack spacing={2} alignItems="center" sx={{ p: 3 }}>
        
        <Link to={`/venda_comercio/consultar/${id}`} color="inherit" underline="hover" component={RouterLink}>
          <Typography variant="subtitle2" noWrap>
            {name}
          </Typography>
        </Link>

        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle0">
            TOTAL
          </Typography>  
          
          <Typography variant="subtitle1">
            <Typography
              component="span"
              variant="body1"
              sx={{
                color: 'text.disabled',
                textDecoration: 'line-through',
              }}
            />
            &nbsp;
            {fFormataDinheiro(price)}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
}
